module.exports = __webpack_public_path__ + "static/miasto_mlawa-be5522d85a02c9bd5e7d44d41c6160b1.png";